<template>

	<div class="autops">
		<el-row :gutter="20" style="width: 100%;    margin-left: -0px;    margin-right: -10px;">
			<el-col :span="11" style="padding:0;">
				<el-table border stripe :data="tableData" header-row-class-name="table-header" fit>
					<el-table-column type="selection" width="40" align="center"> </el-table-column>
					<el-table-column prop="order" label="序号" width="45" align="center">
					</el-table-column>
					<el-table-column prop="name" label="姓名" width="50" align="center">
					</el-table-column>
					<el-table-column prop="studentCode" label="学号" align="center">
						<span class="studentname" slot-scope="scope" @click="studentInfoDialog(scope.row.studentID)">{{scope.row.studentCode}}</span>
					</el-table-column>
					<el-table-column prop="genderName" label="系部" align="center">
					</el-table-column>
					<el-table-column prop="genderName" label="年级" width="60" align="center">
					</el-table-column>
					<el-table-column prop="cName" label="班级" align="center">
					</el-table-column>

				</el-table>
			</el-col>
			<el-col :span="2" style="width: 7.33333%;text-align:center;">
				<div>
					<img src="../../../static/images/bathocco/ruzhu.png" style="margin-top:180px;">
					<p>入住</P>
				</div>
			</el-col>
			<el-col :span="12" style="width:46.83333%;padding:0;border:1px dashed #cccccc; height: 570px;overflow: auto;">
				<el-form :inline="true" class="demo-form-inline" :model="formData">
					<el-form-item label="楼栋:" style="width:33%">
						<el-input v-model="formData.buildingUnitName" placeholder="请选择或者输入楼栋" style="cursor:pointer;width: 90px" suffix-icon="el-icon-arrow-down"></el-input>

					</el-form-item>

					<el-form-item label="楼层:" style="width:33%">
						<el-select v-model="formData.floor" placeholder="请选择" style="width:90px">
							<el-option v-for="item in floorList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="宿舍号:" style="width:31%">
						<el-input v-model="formData.domitoryCode" placeholder="宿舍号" style="width: 80px"></el-input>
					</el-form-item>
				</el-form>
				<div style="text-align:center;">
					<ul class="ruzhusushe">
						<li @click="Select">
							<div class="limask">
							</div>
							<span class="sushehao">2-201</span>
							<el-badge :value="value" :max="99" :class="value>0?'item':'item red'">
								<img src="../../../static/images/bathocco/sushe2.png" class="badgeimage" />
							</el-badge>
							<img src="../../../static/images/bathocco/selected.png" class="selected">
						</li>
						<li>
							<div class="limask">
							</div>
							<span class="sushehao">2-201</span>
							<el-badge :value="lingvalue" :max="99" :class="lingvalue>0?'item':'item red'">
								<img src="../../../static/images/bathocco/sushe2.png" />
							</el-badge>
							<img src="../../../static/images/bathocco/selected.png" class="selected">
						</li>
						<li>
							<div class="limask">
								<img src="" />
							</div>
							<span class="sushehao">2-201</span>
							<img src="../../../static/images/bathocco/sushe2.png" />
						</li>
						<li>
							<span class="sushehao">2-201</span>
							<img src="../../../static/images/bathocco/sushe2.png" />
						</li>
					</ul>
					<div style='clear:both;'></div>
					<div class="form-opres" >
				<el-button @click="submitForm" type="primary" class="u-btn">确定</el-button>
				<el-button @click="back" class="u-btn">返回</el-button>
			</div>
				</div>
			</el-col>
		</el-row>

	</div>

</template>

<script>
	export default {
		name: 'BackToTop',
		props: {
			visibilityHeight: {
				type: Number,
				default: 400
			},
		},
		data() {
			return {
				value: 3,
				lingvalue: 0,
				autoform: {
					sex: '',
					type: [],
					ld: ''
				},
				deptProps: {
					label: 'deptName',
					children: 'zones',
					isLeaf: 'leaf'
				}, // 部门数据
				buildingUnitSelectShow: false,
				formData: {
					deptName: "", // 部门
					deptValue: "",
					buildingUnitId: "", // 楼栋
					buildingUnitName: "",
					domitoryCode: "", // 宿舍号
					studentName: "", // 学生姓名
					studentCode: "", // 学号
					startDate: "", // 开始时间
					endDate: "", // 结束时间
					floorId: "", // 楼层
					attendanceStatusValue: "" //考勤状态码,
				},
				floorList: [{
					value: '0',
					label: '一楼'
				}, {
					value: '1',
					label: '二楼'
				}, {
					value: '2',
					label: '三楼'
				}, {
					value: '3',
					label: '四楼'
				}],
				tableData: [{
					order: 1,
					studentCode: '201804040',
					studentID: '001',
					name: '曹曉',
					studentInfo: {
						name: '曹曉',
						gender: '男',
						studentCode: '201804040',
						bornDate: '1995.1.2',
						cName: '挖掘机3071班',
						beforePicInfo: {
							date: '2017-09-05 11:32:05',
							url: '图片1'
						},
						afterPicInfo: {
							date: '2018-07-05 20:32:05',
							url: '图片2'
						}
					},
					gender: '0',
					genderName: '二年级',
					cName: '挖掘机3071班',
					buildingUnit: '男生宿舍',
					domitoryCode: '101',
					attendanceDate: '2018-07-05',
					scanningTime: '1',
					statusCode: '1',
					statusName: '正常',
					recentScanningDate: '2018-07-05 20:32:05',
					picUrl: '男生宿舍'
				}, {
					order: 1,
					studentCode: '201804050',
					studentID: '002',
					name: '王顺',
					studentInfo: {
						name: '王顺',
						gender: '女',
						studentCode: '201804050',
						bornDate: '1995.2.2',
						cName: '汽修3072班'
					},
					gender: '1',
					genderName: '一年级',
					cName: '汽修3072班',
					buildingUnit: '女生宿舍',
					domitoryCode: '302',
					attendanceDate: '2018-07-05',
					scanningTime: '2',
					statusCode: '3',
					statusName: '晚歸',
					recentScanningDate: '2018-07-05 20:32:05',
					picUrl: '男生宿舍'
				}]
			}
		},
		mounted() {

		},
		methods: {
			// 获取树节点
			getTreeChildNode(node, resolve) {
				if(node.level === 0) {
					return resolve([{
						deptName: '惟楚有才',
						deptId: 0
					}]);
				}
				if(node.level > 1) return resolve([]);

				setTimeout(() => {
					const data = [{
						deptName: '一班',
						deptId: '01',
						leaf: true
					}, {
						deptName: '二班',
						deptId: '02',
					}];

					resolve(data);
				}, 500);
			},
			handleNodeClick(data, Node) {
				this.formData.deptValue = data.deptName;
				this.formData.detpName = data.deptId;
				// 关闭选择器
				this.isShowSelect = false;
			},
			Select() {

			},
			back() {

			},
			submitForm() {
				console.log(this.$parent)

			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.autops {
		.el-checkbox+.el-checkbox {
			margin-left: 0px;
		}
		.ruzhusushe {
			min-height: 468px;
			li {
				text-align: center;
				width: 102px;
				height: 102px;
				position: relative;
				float: left;
				margin: 0 23px 30px 23px;
				cursor: pointer;
				p {
					padding: 0;
					margin: 0;
					font-size: 12px;
				}
				.sushehao {
					position: absolute;
					color: white;
					font-size: 12px;
					top: 43px;
					left: 36px;
					z-index: 500;
				}
				.limask {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: black;
					opacity: .2;
					z-index: 501;
				}
				.badgeimage {
					margin-top: 5px;
				}
				.selected {
					position: absolute;
					margin-top: -24px;
					top: 50%;
					left: 50%;
					margin-left: -24px;
					z-index: 502;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/BatchOccupancysearch/index.vue